import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BookmarkService } from 'src/app/components/bookmarks/bookmark.service';
import { BookmarkItem, BookmarkGroup } from 'src/app/components/bookmarks/bookmarks';
import { Observable } from 'rxjs';
import { FormAction } from 'src/app/components/action-form/form-action';
import { NavigateService } from 'src/app/services/navigate.service';

@Component({
    selector: 'app-bookmarks-tab',
    templateUrl: './bookmarks-tab.component.html',
    styleUrls: ['./bookmarks-tab.component.scss'],
    providers: [TranslatePipe],
    standalone: false
})
export class BookmarksTabComponent implements OnInit {

  public bookmarks$: Observable<BookmarkGroup<BookmarkItem>[]>;
  public oldBookmarks$: Observable<BookmarkGroup<BookmarkItem>[]>; // Todo: remove

  constructor(
    private bookmarkService: BookmarkService,
    private navigateService: NavigateService,
    private translatePipe: TranslatePipe
  ) { 
    this.bookmarks$ = this.bookmarkService.bookmarks$;
    this.oldBookmarks$ = this.bookmarkService.oldBookmarks$;
  }

  ngOnInit(): void {
    this.refresh();
  }

  public refresh() {
    this.bookmarkService.refresh();
  }

  public toggleSelection(item: BookmarkItem) {
    
    item.selected = !item.selected;
  }

  public removeBookmark(event: any, item: BookmarkItem) {
    event.stopPropagation();
    this.bookmarkService.removeBookmark(item);
  }

  public getGroupKey(key) {
    return this.translatePipe.transform(key);
  }

  public goto(event: any, item: BookmarkItem) {
    event.stopPropagation();
   
    switch (item.type) {
      case 'INVOICE':
        this.navigateService.navigateToPage('invoice', item.id, item.type);
        break;
      case 'INVOICETYPEID-1':
        this.navigateService.navigateToPage('invoice', item.id, item.type);
        break;
      case 'CLAIM':
        this.navigateService.navigateToPage('claim', item.id, item.type);
        break;
      default:
        break;
    }
  }

  public formActions(group: string): FormAction[] {
    if(group === 'INVOICE') return [...this.invoiceActions, ...this.defaultGroupActions];

    return [...this.defaultGroupActions];
  }

  public oldFormActions: FormAction[] = [
    {
      text: 'Remove all',
      actionHandler: (group: BookmarkGroup<BookmarkItem>) => this.bookmarkService.removeOldBookmarkGroup(group),
    },
  ];

  private defaultGroupActions: FormAction[] = [
    {
      text: 'Select all',
      actionHandler: (group: BookmarkGroup<BookmarkItem>) => this.selectAll(group),
      disabled: (group: BookmarkGroup<BookmarkItem>) => !group.members.some(b => !b.selected),
    },
    {
      text: 'Deselect all',
      actionHandler: (group: BookmarkGroup<BookmarkItem>) => this.deselectAll(group),
      disabled: (group: BookmarkGroup<BookmarkItem>) => !group.members.some(b => !!b.selected),
    },
    {
      text: 'Remove selected',
      actionHandler: (group: BookmarkGroup<BookmarkItem>) => this.bookmarkService.removeSelected(group),
      disabled: (group: BookmarkGroup<BookmarkItem>) => !group.members.some(b => !!b.selected),
    },
    {
      text: 'Remove all',
      actionHandler: (group: BookmarkGroup<BookmarkItem>) => this.bookmarkService.removeBookmarkGroup(group),
    },
  ];

  private invoiceActions: FormAction[] = [
    // {
    //   text: 'Send to polis',
    //   actionHandler: (group: BookmarkGroup<BookmarkItem>) => {},
    //   disabled: (group: BookmarkGroup<BookmarkItem>) => !group.members.some(b => !!b.selected),
    // }
  ];

  private selectAll(group: BookmarkGroup<BookmarkItem>) {
    group.members.forEach(b => b.selected = true);
  }

  private deselectAll(group: BookmarkGroup<BookmarkItem>) {
    group.members.forEach(b => b.selected = false);
  }

}
